$(function () {
    if ($(".js-quiz-game").length > 0) {
        $(".js-quiz-game-answer").click(function (e) {
            let page = $(this).attr("data-page");
            let btn = $(`.js-quiz-game[data-page="${page}"]`).find(
                ".js-quiz-game-submit"
            );
            btn.removeAttr("disabled");
        });

        $(".js-quiz-game-submit").click(function (e) {
            let nextPage = $(this).attr("data-next");
            if (nextPage == "thanks") {
                return;
            }
            $(".js-quiz-game").addClass("d-none");
            $(`.js-quiz-game[data-page="${nextPage}"]`).removeClass("d-none");
        });
    }

    if ($(".js-quiz-btn-thanks").length > 0) {
        $(".js-quiz-btn-thanks").click(function (e) {
            parent.blazeIT.triggerComponentAction("Btn_Exibition");
            parent.blazeIT.getComponentByName("Btn_GameZone").set('pressed', false);
            parent.blazeIT.getComponentByName("Btn_Exibition").set('pressed', true);
            parent.blazeIT.hideComponent("ShowPopup_Quiz");
        });
    }
});
